import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const LogoRatingAvailability = ({ rating }) => {
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "rating", children: rating }), _jsx("span", { className: "max_rating", children: "/ 5" })] }));
};
export default LogoRatingAvailability;
